const xhr = new XMLHttpRequest
const authorizationKey = '9-0BW1qW9JK5rbQTU_9Hnv6s_kcxODZmRHtAnyE2XSI'
const airportsName = ['Dijon', 'Dole', 'Genève'] as Array<string>
const airports = ['lfsd', 'lfgj', 'lsgg'] as Array<string>
const METARresults = [] as Array<string>
const metarList = document.querySelector('.metars-list') as HTMLElement
const metarSkeletonTemplate = document.querySelector('.metar-skeleton-template') as HTMLTemplateElement
const metarTemplate = document.querySelector('.metar-item-template') as HTMLTemplateElement

for (let i = 0; i < airports.length; i++) {
    metarList.append(metarSkeletonTemplate.content.cloneNode(true))
}

// @ts-ignore
window.addEventListener('load', async function() {
    for (let i = 0; i < airports.length; i++) {
        await prepareMETARRequest(airports[i])
    }
    metarList.innerHTML = ''
    if (METARresults.length == 3) {
        showThemToWorld()
    }

})

// @ts-ignore
async function prepareMETARRequest(metar: string) {
    xhr.open('GET','https://avwx.rest/api/metar/' + metar, true)
    xhr.setRequestHeader('Authorization', authorizationKey)
    await sendMETARRequest(xhr).then(() => {
        METARresults.push(xhr.response['raw'])
    }).catch(() => {
        METARresults.push('METAR indisponible.')
    })
}

async function sendMETARRequest(xhr: XMLHttpRequest) {
    // @ts-ignore
    return new Promise(((resolve, reject) => {
        xhr.responseType = 'json'
        xhr.onload = resolve
        xhr.onerror = reject
        xhr.send()
    }))
}

function showThemToWorld() {
    for (let i = 0; i < airports.length; i++) {
        const metarItem = metarTemplate.content.cloneNode(true) as HTMLElement
        metarItem.querySelector('[data-title]').textContent = airportsName[i]
        metarItem.querySelector('[data-body]').textContent = METARresults[i]
        metarList.append(metarItem)
    }
}